package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.Universe
import fr.manyverse.app.domain.model.UniverseConfig
import fr.manyverse.app.domain.repository.UniverseRepository
import fr.manyverse.app.domain.validation.UniverseValidator

class UpdateUniverseUseCase(
    private val universeRepository: UniverseRepository
) {
    suspend operator fun invoke(
        id: String,
        name: String,
        config: UniverseConfig
    ): Result<Universe> {
        UniverseValidator.validateForCreation(name, config).onFailure {
            return Result.failure(it)
        }
        val finalName = name.trim()
        val finalConfig = config.copy(
            version = config.version + 1,
            displayName = finalName
        )
        return universeRepository.updateUniverse(id, finalName, finalConfig)
    }
}
